import { render } from "./ResendPaymentView.vue?vue&type=template&id=7c7ca2d6"
import script from "./ResendPaymentView.vue?vue&type=script&lang=js"
export * from "./ResendPaymentView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__